import FormRow from 'Components/FormRow';
import FormSection from 'Components/FormSection';
import InputHandler from 'Components/InputHandler';
import * as React from 'react';
import { optionFormatter } from '../../../utils/functions';

const SMAform = ({ editing, formData }: IOwnProps): React.JSX.Element => {
  return (
    <React.Fragment>
      <FormRow title="diagnosis.symptomOnsetDate" headerWidth={4}>
        <InputHandler
          type="PartialDate"
          editing={!!editing}
          name="symptomOnsetDate"
          formData={formData}
          dateDefault="now"
        />
      </FormRow>
      <FormSection header="diagnosis.sma">
        <FormRow title="diagnosis.smaType" headerWidth={4}>
          <InputHandler
            type="Radio"
            editing={!!editing}
            name="smaType"
            formData={formData}
            options={['1', '2', '3']}
            disabledOptions={formData.document.diagnosis === 'G12.0' ? ['2', '3'] : ['1']}
          />
        </FormRow>
        <FormRow title="diagnosis.smaGeneticConfirmation" headerWidth={4}>
          <InputHandler
            type="Radio"
            editing={!!editing}
            name="smaGeneticConfirmation"
            formData={formData}
            preset={'yesno'}
          />
        </FormRow>
      </FormSection>
      <FormSection
        header="diagnosis.smaGeneticConfirmationTitle"
        condition={formData.document.smaGeneticConfirmation === true}
      >
        <FormRow title="diagnosis.smaGeneticScreened" id={'geneticScreened'} headerWidth={4}>
          <InputHandler
            type="Radio"
            editing={!!editing}
            name="smaGeneticScreened"
            formData={formData}
            preset={'yesno'}
          />
        </FormRow>
        <FormRow title="diagnosis.smaGeneticDate" headerWidth={4}>
          <InputHandler
            type="PartialDate"
            editing={!!editing}
            name="smaGeneticDate"
            formData={formData}
            dateDefault="now"
          />
        </FormRow>
        <FormRow title="diagnosis.smaSMN1MutationName.title" headerWidth={4}>
          <InputHandler
            type="Radio"
            editing={!!editing}
            name="smaSMN1MutationName"
            formData={formData}
            options={['SMN1homozygousdeletion', 'SMN1heterozygousdeletion', 'Compoundheterozygous']}
            optionFormatter={optionFormatter('smaSMN1MutationName.opts')}
          />
        </FormRow>
        <FormRow title="diagnosis.smaSMN1TestingMethod.title" headerWidth={4}>
          <InputHandler
            type="Radio"
            editing={!!editing}
            name="smaSMN1TestingMethod"
            formData={formData}
            options={['RFLP', 'HRM', 'MLPA', 'LuminexGenotyping', 'qrtPCR', 'ddPCR', 'Other', 'Unknown']}
            optionFormatter={optionFormatter('smaSMN1TestingMethod.opts')}
          />
        </FormRow>
        <FormRow
          title="diagnosis.smaTestingMethodOther"
          condition={formData.document.smaSMN1TestingMethod === 'Other'}
          headerWidth={4}
        >
          <InputHandler
            type="TextField"
            editing={!!editing}
            name="smaSMN1TestingMethodOther"
            formData={formData}
            placeholder="diagnosis.smaTestingMethodOtherPlaceholder"
          />
        </FormRow>
        <FormRow title="diagnosis.smaSMN2CopyNumberTested" id={'smn2Tested'} headerWidth={4}>
          <InputHandler
            type="Radio"
            editing={!!editing}
            name="smaSMN2CopyNumberTested"
            formData={formData}
            preset={'yesno'}
          />
        </FormRow>
        {formData.document.smaSMN2CopyNumberTested === true ? (
          <React.Fragment>
            <FormRow title="diagnosis.smaSMN2TestingMethod.title" id={'smn2TestingMethod'} headerWidth={4}>
              <InputHandler
                type="Radio"
                editing={!!editing}
                name="smaSMN2TestingMethod"
                formData={formData}
                options={['RFLP', 'HRM', 'MLPA', 'LuminexGenotyping', 'qrtPCR', 'ddPCR', 'Other', 'Unknown']}
                optionFormatter={optionFormatter('smaSMN2TestingMethod.opts')}
              />
            </FormRow>
            <FormRow
              title="diagnosis.smaTestingMethodOther"
              condition={formData.document.smaSMN2TestingMethod === 'Other'}
              headerWidth={4}
            >
              <InputHandler
                type="TextField"
                editing={!!editing}
                name="smaSMN2TestingMethodOther"
                formData={formData}
                placeholder="diagnosis.smaTestingMethodOtherPlaceholder"
              />
            </FormRow>
            <FormRow title="diagnosis.smaSMN2CopyNumber" id={'smn2CopyNumber'} headerWidth={4}>
              <InputHandler
                type="Radio"
                editing={!!editing}
                name="smaSMN2CopyNumber"
                formData={formData}
                options={['0', '1', '2', '3', '4+']}
              />
            </FormRow>
          </React.Fragment>
        ) : undefined}
      </FormSection>
    </React.Fragment>
  );
};

interface IOwnProps {
  editing?: string;
  formData: IFormData<IDocumentWithTypeV2<'diagnosis'>>;
}

export default SMAform;
